import {
    Component,
    OnInit,
    ChangeDetectorRef,
    OnDestroy,
    ViewChild,
    HostListener,
    NgZone,
    Input,
    ElementRef,
    signal,
    TemplateRef
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DisplayItemInterface } from 'src/app/model/marketplace/display-item-interface';
import { DataType } from 'src/app/model/data-type.enum';
import { MarketplaceService } from 'src/app/services/dataServices/marketplace-service/marketplace.service';
import { DtoPageFactory } from 'src/app/model/marketplace/dto-page-factory';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { merge, Subject, Subscription } from 'rxjs';
import { UPDATE_DELAY_IN_MS } from 'src/environments/constants';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { CheckBoxCategorie } from 'src/app/model/marketplace/marketplace-checkbox';
import {
    animate,
    AUTO_STYLE,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay, skip } from 'rxjs/operators';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { MarketplaceFilterService } from 'src/app/services/componentServices/marketplace-filter-service/marketplace-filter.service';
import { ProductlistService } from 'src/app/services/productlist-service/productlist.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { SortMethod } from 'src/app/model/enums/SortMethod';
import { ProductCategory } from 'src/app/model/enums/productCategory';
import { CategoryService } from 'src/app/services/dataServices/product-service/categoryService';
import { productCategoryDto } from 'src/app/model/category/productCategoryDto';
import { ProductDetailDisplayFullComponent } from './detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { AssetPropertiesDialogComponent } from './subcomponents/asset-properties-dialog/asset-properties-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MarketPlaceSideFilterComponent } from './subcomponents/marketplace-side-filter/market-place-side-filter.component';
import { MarketplaceFilterInterface } from 'src/app/model/marketplace/marketplace-filter-interface';
import { MatSidenav } from '@angular/material/sidenav';
import {
    getLocalStorageItem,
    removeLocalStorageItem
} from 'src/app/utils/browser-storage';

@Component({
    selector: 'app-marketplace-overview',
    animations: [
        trigger('openClose', [
            state('open', style({
                height: AUTO_STYLE
            })),
            state('closed', style({
                height: '0'
            })),
            transition('* => *', [animate('0.2s ease-out')])
        ])
    ],
    templateUrl: './marketplace-overview.component.html',
    styleUrls: ['./marketplace-overview.component.scss'],
    standalone: false
})
export class MarketplaceOverviewComponent implements OnInit, OnDestroy {
    get totalNrOfItems(): number {
        return this.marketplaceService.totalNrOfItems;
    }
    hideSingleSelectionIndicator = signal(true);

    constructor(
        private dialog: MatDialog,
        private breakpointObserver: BreakpointObserver,
        private marketplaceService: MarketplaceService,
        private productService: ProductService,
        private headerService: HeaderServiceService,
        private certificationService: CertificationService,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef,
        public router: Router,
        private titleService: Title,
        private organisationService: OrganisationService,
        public marketPlaceFilterService: MarketplaceFilterService,
        private productListService: ProductlistService,
        private dialogService: DialogService,
        private userService: UserService,
        private zone: NgZone,
        private categoryService: CategoryService
    ) {
        this.products = Array(100)
            .fill(0)
            .map((x, i) => i);

    }

    /**
     * State indicator to switch between different display types.
     */
    get displaySetting() {
        return this.marketplaceService.filterService.marketScreenState;
    }
    /**
     * Array of items to display.
     */
    @ViewChild('tab', { static: false }) tab: MatTabGroup;
    @ViewChild('gridContainer', { static: false }) gridContainer!: ElementRef;
    @ViewChild(MarketPlaceSideFilterComponent) sideFilterComponent: MarketPlaceSideFilterComponent;
    @ViewChild('drawer', { static: false }) drawer: MatSidenav;
    public displayItem: DisplayItemInterface[] = [];

    private isGoBack = true;
    public loading = true;
    public displaySize = 25;
    public pageIndex: number = this.marketPlaceFilterService.pageIndex;

    public changeDetected = false;
    public subscription: Subscription;
    public queryParamSubscription: Subscription;
    public tabsDisabled = [false, false, false];
    public searchText = '';
    public showNoResults = false;
    public activeFilterChips: { label: string, id: number | string, category: string }[] = [];
    orderByOrganisationFlag = false;

    public marketplaceCloseSubscription: Subscription;
    public clearFilterSubscription: Subscription;

    products: number[];
    producttypeFilterString = '';
    providerFilterString = '';

    showProducttypeFilter = false;
    showProviderFilter = false;
    filterSpinner = false;
    showDetails = false;
    @Input() clearNav = false;
    spinner = true;
    displaySpinner = false;

    actualProduct: ProductInterface;
    actualCertification: CertificationInterface;
    actualOrganisation: OrganisationInterface;
    @ViewChild('organisationDetailsDialog') organisationDetailsDialog: TemplateRef<unknown>;
    private organisationDialogRef: MatDialogRef<unknown>;
    private organisationDialogCloseSubscription: Subscription;
    private organisationDialogRequest = 0;

    async openOrganisationDialog(id: number): Promise<void> {
        const request = ++this.organisationDialogRequest;
        try {
            const organisation = await this.organisationService.getOrganisation(id);
            if (request !== this.organisationDialogRequest
                || this.marketplaceService.filterService.marketScreenState !== DataType.ORGANISATION) return;
            this.actualOrganisation = organisation;
            this.actualOrganisation.name = organisation.organisationName;
            this.showDetails = true;
            this.openOrganisationDetailsDialog();
        } catch (error) {
            console.error('Error loading organisation details:', error);
        }
    }

    closeOrganisationDialog(): void {
        ++this.organisationDialogRequest;
        this.organisationDialogRef?.close();
        this.showDetails = false;
    }

    private openOrganisationDetailsDialog(): void {
        if (this.organisationDialogRef) return;
        const reference = this.dialog.open(this.organisationDetailsDialog, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            ariaLabel: this.actualOrganisation.organisationName
        });
        this.organisationDialogRef = reference;
        this.organisationDialogCloseSubscription = reference.afterClosed().subscribe(() => {
            this.organisationDialogRef = null;
            this.showDetails = false;
        });
    }
    filterServiceSubscription: Subscription;
    public marketScreenState: DataType;
    loggedIn = true;
    /**
     * The update Timer to delay backend request between
     * a sequence of manipulationens
     */
    private updateDelay;
    public tmpUrl = ''
    SortMethod = SortMethod; // expose enum to template
    sortMethodOptions = Object.values(SortMethod);
    public sortOptions = buildSortOptions(this.marketPlaceFilterService.marketScreenState);
    sortMethod: SortMethod = SortMethod.DATE_DESC;
    searchInput$ = new Subject<string>();
    isHandset$: Observable<boolean> = this.breakpointObserver
        .observe(Breakpoints.Handset)
        .pipe(
            map((result) => result.matches),
            shareReplay()
        );
    itemsPerRow: number = 4;

    private buildCategoryCheckboxItems(categories: productCategoryDto[]): void {
        const dynamicItems = categories.sort((a, b) => a.position - b.position).map(cat => {
            let displayName: string;
            switch (cat.name.toLowerCase()) {
                case 'app':
                    displayName = 'Software';
                    break;
                case 'service':
                    displayName = 'KI-Dienste';
                    break;
                case 'robots':
                    displayName = 'Roboter';
                    break;
                case 'content':
                    displayName = 'Fachpublikationen';
                    break;
                case 'db':
                    displayName = 'Datenbanken';
                    break;
                default:
                    displayName = cat.name;
            }

            return {
                name: displayName,
                checked: displayName === this.selectedFilter,
                value: cat.name,
                filterOption: cat.filterOption
            };
        });
        this.productCategoryCheckboxItems = [
            {
                name: 'Alle',
                checked: this.selectedFilter === 'Alle',
                value: 'ALL',
                filterOption: true
            },
            ...dynamicItems
        ];
        this.visibleCategoryItems = this.productCategoryCheckboxItems.filter(item => item.filterOption);
        const initialTab = this.route.snapshot.queryParams['tab'];
        if (!initialTab || initialTab === '0') {
            this.onFilterChanged(this.selectedFilter);
        }
    }

    onActiveFiltersChange(filter: MarketplaceFilterInterface) {
        if (!this.sideFilterComponent) return;
        this.activeFilterChips = [];

        // TO-DO
        // filter.attributeIds?.forEach(attrId => {
        //         this.activeFilterChips.push({ label: "name", id: attrId, category: 'attribute' });
        // });

        filter.certificationIds?.forEach(certId => {
            const entry = this.sideFilterComponent._checkBoxes[CheckBoxCategorie.CERTIFICATION]?.find(i => i.id === certId);

            if (entry && entry.isChecked) {
                this.activeFilterChips.push({ label: entry.label, id: certId, category: 'certification' });
            }
        });

        filter.organisationIds?.forEach(orgId => {
            const entry = this.sideFilterComponent._checkBoxes[CheckBoxCategorie.ORGANISATION]?.find(i => i.id === orgId);

            if (entry && entry.isChecked) {
                this.activeFilterChips.push({ label: entry.label, id: orgId, category: 'organisation' });
            }
        });

        filter.ptgIds?.forEach(ptgId => {
            const entry = this.sideFilterComponent._checkBoxes[CheckBoxCategorie.PTG]?.find(i => i.id === ptgId);
            if (entry && entry.isChecked) {
                this.activeFilterChips.push({ label: entry.label, id: ptgId, category: 'ptg' });
            }
        });

        filter.ratingScore?.forEach(scoreId => {
            this.activeFilterChips.push({ label: `${scoreId}`, id: scoreId, category: 'rating' });

        });

        filter.commonFeatureIds?.forEach(commonFeatureId => {
            for (const featureGroup of this.sideFilterComponent.commonFeatures) {
                const entry = featureGroup.entries?.find(e => e.id === commonFeatureId);
                if (entry && entry.isChecked) {
                    this.activeFilterChips.push({ label: entry.name, id: commonFeatureId, category: 'commonfeature' });
                    break;
                }
            }
            // TODO: this is a workaround for common feature "Zielgruppen -> Fachplaner" sub entries.
            // This logic should be handled in backend-service
            const fachPlanerEntry = this.sideFilterComponent.fachPlanerEntries
                .find(e => e.id === commonFeatureId);
            if (fachPlanerEntry && fachPlanerEntry.isChecked) {
                this.activeFilterChips.push({
                    label: fachPlanerEntry.pureName.split(';')[1],
                    id: commonFeatureId,
                    category: 'commonfeature'
                });
            }
        });
        this.cd.detectChanges();
    }

    removeFilterChip(chip: { label: string, id: number | string, category: string }) {
        this.sideFilterComponent?.removeFilterByChip(chip);
    }

    ngOnInit() {
        // handling the queryparams in the url for the filter or selection of product/cert/orga displayitem and
        // basically changing the settings of the site to the url parameters
        this.loadQueryParams();
        this.categoryService.categories$.subscribe(categories => {
            this.buildCategoryCheckboxItems(categories);
        });
        this.spinner = true;
        this.displaySpinner = false;
        this.subscribeToOrder();
        this.titleService.setTitle('Marktplatz - Construct-X');
        this.headerService.loadHeaderText('Marktplatz');
        const filter = this.marketplaceService.filterService;
        this.marketplaceService.open$.subscribe(() => {
            if (this.drawer) {
                this.drawer.open();
            }
        });
        this.marketplaceService.toggle$.subscribe(() => {
            if (this.drawer) {
                this.drawer.toggle();
            }
        });
        this.marketplaceService.close$.subscribe(() => {
            if (this.drawer) {
                this.drawer.close();
            }
        });
        // ######################################################
        // register the overview for all causes that change the
        // filter settings, and merge them into one steram
        // ######################################################
        this.route.queryParamMap.subscribe(params => {
            this.loadQueryParams();
            this.loading = false;
        });


        let marketplaceChanges$ = merge(
            filter.screenStateObservable,
            filter.filterChangeObservable,
            filter.searchTextSubject,
            filter.sortingOptionSubject,
        );

        this.subscription = marketplaceChanges$.subscribe((_) => {
            this.changeDetected = true;
            // ######################################################
            // this sets a delay timer that is "restarted" everytime
            // there is a new update request send to the display.
            // this prevents unnecessary backend request when
            // the filter changes to quickly f.i. when typing a
            // searchterm or toggling filter icons quickly
            // #####################################################

            if (this.updateDelay) {
                clearTimeout(this.updateDelay);
            }
            this.updateDelay = setTimeout(() => {
                this.pageIndex = 0;
                if (this.queryParamSubscription) {
                    this.queryParamSubscription.unsubscribe();
                }

                this.loadDisplayItems().then(() => {
                    this.queryParamSubscription =
                        this.route.queryParams.subscribe((params) => {
                            this.handleQueryParamSubscription(params);
                        });
                    this.changeDetected = false;
                });
            }, UPDATE_DELAY_IN_MS);

            // ######################################################
            // this registers the marketplace component to the route
            // parameter map.
            // this way a different component can use the navigation
            // parameters as a way to set the marketplace filter
            // without the need to inject the sidemenu filter service
            // ######################################################
            this.route.paramMap.subscribe((x) => {
                if (x.get('organisation')) {
                    const organisationToFilter = parseInt(
                        x.get('organisation')
                    );
                    filter.addFilter(
                        organisationToFilter,
                        CheckBoxCategorie.ORGANISATION
                    );
                }
            });

            // ---------------------------------------------------------
        });
        this.userService.currentUserObservable.subscribe((user) => {
            if (user && this.userService.loggedIn) {
                this.loggedIn = this.userService.loggedIn;
            } else {
                this.loggedIn = false;
                this.headerService.setMenuTabs([]);
            }
        });

        const initialTab = this.route.snapshot.queryParams['tab'];
        if (initialTab === '1') {
            this.marketPlaceFilterService.changeToCertificationScreen();
        } else if (initialTab === '2') {
            this.marketPlaceFilterService.changeToOrganisationScreen();
        } else {
            this.marketPlaceFilterService.changeToProductScreen();
        }
        this.marketPlaceFilterService.screenStateObservable.subscribe(
            (marketScreenState) => {
                this.marketScreenState = marketScreenState;
            }
        );
        if (this.userService.loggedIn) {
            this.productListService.getAllProducts();
        }
        this.marketPlaceFilterService.getChangeProductCategoryFilter().subscribe((filter) => {
            if (filter != "none") this.onFilterChanged(filter);
        })

        this.clearFilterSubscription = this.marketPlaceFilterService
            .getToggleBooleanClearFilter()
            .subscribe((response) => {
                if (response) {
                    this.marketPlaceFilterService.setToggleBooleanClearFilter(
                        false
                    );
                    this.goBack();
                    if (this.router.url.startsWith('/marktplatz')) {
                        this.router.navigateByUrl('/marktplatz?tab=0');
                    }
                    this.cd.detectChanges();
                }
            });
    }

    onMainSearchInput(value: string): void {
        this.searchInput$.next(value);
    }

    disableAllTabs(): void {
        this.tabsDisabled = [true, true, true];
    }

    enableAllTabs(): void {
        this.tabsDisabled = [false, false, false];
    }

    openProductDialog(title: string, product: ProductInterface): void {
        this.openProductDetailsPageDialog(title, product).subscribe((result) => {
            if (result.isBookmarkedChanged) {
                this.pageIndex = 0;
                this.productListService.getAllProducts();
                this.loadDisplayItems();
                this.cd.detectChanges();
            }
        });
    }

    openProductDetailsPageDialog(
        title: string,
        product: ProductInterface
    ): Observable<any> {
        const reference = this.dialog.open(ProductDetailDisplayFullComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                title: 'Produktübersicht',
                product: product
            }
        });
        return reference.afterClosed();
    }

    openAssetDialog(title: string, item: any): void {
        this.dialog.open(AssetPropertiesDialogComponent, {
            width: '800px',
            maxWidth: '95vw',
            data: {
                title: title,
                product: item
            }
        });
    }

    onSortSelectionChange(event: any) {
        this.pageIndex = 0;
        this.sortMethod = event.value;
        this.loadDisplayItems();
    }

    handleQueryParamSubscription(params: Params) {
        // Set the tab (Produkte, Zertifikate, Anbieter) from url query params if present
        this.resolveTabQueryParam(params['tab']);

        // Open the details of product/certification/organisation with corresponding id from url query if present
        let itemId: number;
        if (params['productId']) {
            itemId = params['productId'];
        } else if (params['certificationId']) {
            itemId = params['certificationId'];
        } else if (params['organisationId']) {
            itemId = params['organisationId'];
        }
        this.resolveDisplayItemQueryParam(itemId);
    }


    private resolveDisplayItemQueryParam(itemId?: number) {
        if (itemId) {
            this.isGoBack = false;
            let item: DisplayItemInterface | undefined;
            for (const displayIt of this.displayItem) {
                if (displayIt.id == itemId) {
                    item = displayIt;
                }
            }
            if (!item) {
                this.spinner = false;
                return;
            }
            this.getDisplayItemDetails(item?.id, item?.subscript)
            .then(() => {
                this.showDetails = true;
                if (this.marketplaceService.filterService.marketScreenState === DataType.ORGANISATION
                    && String(this.route.snapshot.queryParams['organisationId']) === String(itemId)) {
                    this.openOrganisationDetailsDialog();
                }
                if (getLocalStorageItem('redirectingForRating') == 'true') {
                    document
                        .getElementById('ratingPane')
                        ?.scrollIntoView({ behavior: 'smooth' });
                    removeLocalStorageItem('redirectingForRating');
                }
                this.cd.detectChanges();
            })
            .catch(error => {
                console.error('Error resolving display item:', error);
            })
            .finally(() => {
                this.spinner = false;
            });
        }
    }

    changeMarketPlaceScreenState(event: MatTabChangeEvent) {
        this.showDetails = false;
        this.spinner = true;
        switch (event.index) {
            case 0:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToProductScreen();
                this.marketPlaceFilterService.resetFilters();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                this.cd.detectChanges();
                break;
            case 1:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToCertificationScreen();
                this.marketPlaceFilterService.resetFilters();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                this.cd.detectChanges();
                break;
            case 2:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToOrganisationScreen();
                this.marketPlaceFilterService.resetFilters();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                this.cd.detectChanges();
                break;
        }
        this.actualProduct = null;
        this.actualCertification = null;
        this.actualOrganisation = null;
        if (this.isGoBack) {
            this.goBack();
        } else {
            this.isGoBack = true;
        }
        this.cd.detectChanges();
    }

    changeMarketPlaceScreenStateAlways(event: MatTabChangeEvent) {
        switch (event.index) {
            case 0:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToProductScreen();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                break;
            case 1:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToCertificationScreen();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                break;
            case 2:
                this.marketplaceService.filterService.marketScreenState =
                    this.marketplaceService.filterService.changeToOrganisationScreen();
                this.sortOptions = buildSortOptions(this.marketplaceService.filterService.marketScreenState);
                break;
        }
    }

    /**
     * 1) Set the tab in url query to now selected tab 2.
     * 2) Reset all filters from url query, reset by explicitly handing null as value for each filter option key that is available in params
     * @param event Event upon tab change in marketplace overview, event.index is the now selected tab
     */
    changeQueryTab(event: MatTabChangeEvent) {
        this.disableAllTabs();
        const oldTabUrl = this.router.url;
        const oldTabUrlParam = this.router.url.split('?'); // operationen nach dem ?
        let keyParams = oldTabUrlParam[1];
        if (keyParams.includes('&')) {
            keyParams = keyParams.split('&')[0];
        }
        const lastTab = +keyParams.substr(-1);
        const changedToNewTab = lastTab != event.index;

        let queryParams: Params = {
            tab: event.index
        };

        this.changeMarketPlaceScreenStateAlways(event);
        this.spinner = true;
        this.cd.detectChanges();
        if (event.index != 0) this.marketPlaceFilterService.setChangeProductCategoryFilter(ProductCategory.ALL)
        if (event.index == 0) this.marketPlaceFilterService.setChangeProductCategoryFilter(ProductCategory.Software)
        if (changedToNewTab) {
            this.resetAllFilters();
            this.changeMarketPlaceScreenState(event);
            queryParams = {
                tab: event.index,
                productId: null,
                certificationId: null,
                organisationId: null,
                category: null,
                ptgId: null,
                certificationType: null,
                appSubPro: null,
                orgId: null,
                certifiId: null,
                search: this.searchText,
                attr: null,
                rating: null
            };
        }
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge'
        });
        this.spinner = false;
        this.cd.detectChanges();
    }

    private resetAllFilters(): void {
        this.searchText = '';
        this.marketPlaceFilterService.productFilter = [];
        this.marketPlaceFilterService.commonFeatureEntriesFilter = [];
        this.marketPlaceFilterService.setOrgaTypeFilter(null, this.marketPlaceFilterService.productCategories, []);
        this.marketPlaceFilterService.clearAllFilterLists();
    }

    @HostListener('window:scroll')
    onScroll() {
        let x = document.querySelector('.grid');
        if (x == null) {
            x = document.querySelector('.grid2');
        }
        if (x == null) {
            x = document.querySelector('.grid3');
        }
        if (
            x.scrollHeight > document.body.offsetHeight / 2 ||
            x.scrollHeight > window.innerHeight
        ) {
            if (
                this.displayItem.length < this.totalNrOfItems &&
                this.displayItem.length > 5
            ) {
                this.displaySpinner = true;
                this.pageIndex++;
                setTimeout(() => {
                    this.loadNextDisplayPage();
                }, 200);
            }
        }
    }

    subscribeToOrder(): void {
        this.marketplaceService.filterService.orderByOrganisationSubject.subscribe(
            (o) => {
                this.orderByOrganisationFlag = o;
            }
        );
    }

    goBack(): void {
        this.organisationDialogRef?.close();
        this.showDetails = false;
        if (this.route.snapshot.queryParams['appSubPro'] != undefined) {
            this.marketPlaceFilterService.removeFilter(
                this.route.snapshot.queryParams['appSubPro'][0],
                CheckBoxCategorie.PRODUCTS
            );
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                    appSubPro: null,
                    productId: null,
                    certificationId: null,
                    organisationId: null
                },
                queryParamsHandling: 'merge'
            });
        } else if (this.router.url.includes('/marktplatz?tab=1')) {
            if (this.route.snapshot.queryParams['certifiId']) {
                this.marketPlaceFilterService.removeFilter(
                    this.route.snapshot.queryParams['certifiId'][0],
                    CheckBoxCategorie.CERTIFICATION
                );
            }
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                    certifiId: null,
                    productId: null,
                    certificationId: null,
                    organisationId: null
                },
                queryParamsHandling: 'merge'
            });
        } else if (this.router.url.includes('/marktplatz?tab=2')) {
            if (this.route.snapshot.queryParams['orgId']) {
                this.marketPlaceFilterService.removeFilter(
                    this.route.snapshot.queryParams['orgId'][0],
                    CheckBoxCategorie.ORGANISATION
                );
            }
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                    orgId: null,
                    productId: null,
                    certificationId: null,
                    organisationId: null
                },
                queryParamsHandling: 'merge'
            });
        } else {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                    productId: null,
                    certificationId: null,
                    organisationId: null
                },
                queryParamsHandling: 'merge'
            });
        }
        this.cd.detectChanges();
    }

    /**
     * Like LoadDisplyPage but adds the new DisplaySlice instead of replacing local
     */
    private loadNextDisplayPage() {

        const dtoPageRequest = this.createPageRequest();

        // the marketplaceService handles the right api
        const request = this.marketplaceService.getFilteredSlice(
            dtoPageRequest,
            this.displaySetting
        );
        this.marketplaceService
            .getDisplayItems(request)
            .then((displayItem: DisplayItemInterface[]) => {
                this.displayItem = this.displayItem.concat(displayItem);
                this.cd.detectChanges();
            })
            .catch((error) => {
                console.error('Error loading next page:', error);
            })
            .finally(() => {
                this.displaySpinner = false;
                if (!this.cd['destroyed']) {
                    this.cd.detectChanges();
                }
            });
    }

    /**
     * This function does the linking to the detail page.
     * @param link link to navigate to
     */
    onDisplayItemClicked(link: string) {
        if (this.displaySetting === DataType.ORGANISATION) {
            link = '@' + link;
        }
        this.subscription.unsubscribe();
        this.router.navigateByUrl(link);
    }

    /**
     * Loads the current page.
     * Resets display on every load.
     * Redraws display on every load.
     */
    private loadDisplayItems() {
        return new Promise<void>((resolve) => {
            this.spinner = true;
            // -----------------------------------------------------------
            // the createFunction handles the filter
            const dtoPageRequest = this.createPageRequest();
            // the marketplaceService handles the right api
            const request = this.marketplaceService.getFilteredSlice(
                dtoPageRequest,
                this.displaySetting
            );
            this.marketplaceService
                .getDisplayItems(request)
                .then((displayItem: DisplayItemInterface[]) => {
                    this.displayItem = displayItem;
                    this.showNoResults = false;
                    if (
                        this.marketPlaceFilterService.searchText !== '' &&
                        this.displayItem.length === 0
                    ) {
                        this.showNoResults = true;
                    } else if (this.displayItem.length === 0) {
                        this.showNoResults = true;
                    }
                })
                .catch((error) => {
                    console.error('Error loading display items:', error);
                })
                .finally(() => {
                    this.spinner = false;
                    this.marketPlaceFilterService.filterSpinner = false;
                    if (!this.cd['destroyed']) {
                        this.cd.detectChanges();
                    }
                    resolve();
                    this.enableAllTabs();
                });
        });
    }

    /**
     * Loads the current page.
     * Resets display on every load.
     * Redraws display on every load.
     */
    private loadDisplayItem(productId: number) {
        return new Promise<void>((resolve) => {
            // -----------------------------------------------------------
            this.marketplaceService
                .getDisplayItem(productId)
                .then((displayItem: DisplayItemInterface) => {
                    const oldItem: DisplayItemInterface = this.displayItem.find(
                        (item) => item.id === productId
                    );
                    this.cd.detectChanges();
                    resolve();
                });
        });
    }

    changeQueryParams(id: number) {
        if (this.marketplaceService.filterService.marketScreenState === DataType.ORGANISATION) {
            void this.openOrganisationDialog(id);
            return;
        }
        this.spinner = true;
        let queryParams: Params;
        if (
            this.marketplaceService.filterService.marketScreenState ===
            DataType.PRODUCT
        ) {
            queryParams = { productId: id };
        } else if (
            this.marketplaceService.filterService.marketScreenState ===
            DataType.CERTIFICATION
        ) {
            queryParams = { certificationId: id };
        }

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge'
        });
        this.showDetails = true;
        this.spinner = false;
        this.cd.detectChanges();
    }

    getDisplayItemDetails(prodId: number, orgaName: string) {
        return new Promise((resolve, reject) => {
            switch (this.marketplaceService.filterService.marketScreenState) {
                case DataType.PRODUCT:
                    this.productService
                        .getItem(prodId)
                        .then((product) => {
                            this.actualProduct = product;
                            this.actualProduct.organisationName = orgaName;
                            resolve(true);
                        })
                        .catch(reject);
                    break;
                case DataType.CERTIFICATION:
                    this.certificationService
                        .getItem(prodId)
                        .then((certification) => {
                            this.actualCertification = certification;
                            this.actualCertification.organisationName =
                                orgaName;
                            resolve(true);
                        })
                        .catch(reject);
                    break;
                case DataType.ORGANISATION:
                    this.organisationService
                        .getOrganisation(prodId)
                        .then((organisation) => {
                            this.actualOrganisation = organisation;
                            this.actualOrganisation.name =
                                organisation.organisationName;
                            resolve(true);
                        })
                        .catch(reject);
                    break;
                default:
                    reject(new Error(
                        `Unknown data type: ${this.marketplaceService.filterService.marketScreenState}`
                    ));
                    break;
            }
        });
    }

    isLoggedIn(): boolean {
        return this.userService.loggedIn;
    }

    isBookmarked(productId: number, displayType: number) {
        let isBookmarked = false;
        this.productListService
            .getProductList()
            .getValue()
            .forEach((bookmarkedProduct) => {
                if (
                    bookmarkedProduct.id == productId &&
                    bookmarkedProduct.displayType === displayType
                ) {
                    isBookmarked = true;
                }
            });
        return isBookmarked;
    }
    /**
     * Create a dtoPageRequest from the filter of the filterservice
     */
    @HostListener('window:size', [])
    public createPageRequest() {
        this.calculateItemsPerRow();
        const filterService = this.marketplaceService.filterService;
        if (
            Number(window.innerWidth) < 2561 &&
            Number(window.innerHeight) < 1441
        ) {
            DtoPageFactory.bluePrint.pageSize = 30;
        } else if (
            Number(window.innerWidth) < 3841 &&
            Number(window.innerHeight) < 2161
        ) {
            DtoPageFactory.bluePrint.pageSize = 50;
        } else if (
            Number(window.innerHeight) < 7681 &&
            Number(window.innerHeight) < 4321
        ) {
            DtoPageFactory.bluePrint.pageSize = 216;
        }

        DtoPageFactory.loadFilter(filterService.filter);
        DtoPageFactory.bluePrint.pageIndex = this.pageIndex;
        DtoPageFactory.bluePrint.searchTerm = filterService.searchText;
        DtoPageFactory.bluePrint.sortMethod = this.sortMethod;

        if (DtoPageFactory.bluePrint.pageIndex === 0) {
            DtoPageFactory.bluePrint.prioSize = this.itemsPerRow * 2;
        } else {
            DtoPageFactory.bluePrint.prioSize = 0;
        }
        return DtoPageFactory.createDtoPage();
    }

    checkIfFocusForProduct(item: DisplayItemInterface) {
        if (!this.showDetails) {
            return false;
        }
        if (this.actualProduct) {
            return item.id === this.actualProduct.id;
        }
        return false;
    }

    checkIfFocusForCertificate(item: DisplayItemInterface) {
        if (!this.showDetails) {
            return false;
        }
        if (this.actualCertification) {
            return item.id === this.actualCertification.id;
        }
        return false;
    }

    checkIfFocusForOrga(item: DisplayItemInterface) {
        if (!this.showDetails) {
            return false;
        }
        if (this.actualOrganisation) {
            return item.id === this.actualOrganisation.organisationId;
        }
        return false;
    }

    ngOnDestroy(): void {
        ++this.organisationDialogRequest;
        this.organisationDialogCloseSubscription?.unsubscribe();
        this.organisationDialogRef?.close();
        this.subscription.unsubscribe();
        if (this.queryParamSubscription) {
            this.queryParamSubscription.unsubscribe();
        }
        if (this.clearFilterSubscription) {
            this.clearFilterSubscription.unsubscribe();
        }
        this.displayItem = [];

        if (this.filterServiceSubscription) {
            this.filterServiceSubscription.unsubscribe();
        }
    }
    private resolveTabQueryParam(tab?: any) {
        if (tab !== undefined && tab !== null) {
            this.tab.selectedIndex = +tab;
        } else if (this.router.url.startsWith('/marktplatz')) {
            this.tab.selectedIndex = 0;
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { tab: 0 },
                queryParamsHandling: 'merge'
            });
        }
    }

    /**
     * this function is there to take the previous Queryparams that came with the link
     * and restore the page with all the parameters when a detail page is opened
     */
    private loadQueryParams(): void {

        const params = this.route.snapshot.queryParams;
        if (params['category']) {
            const category = params['category'];
            this.selectedFilter = category;
            this.cd.detectChanges();
        }
        if (params['search']) {
            const search = params['search'];
            this.marketPlaceFilterService.searchText = search;
            this.searchText = search;
            this.cd.detectChanges();
        }

        if (!this.router.url.startsWith('/marktplatz')) {
            return;
        }

        let mainId: any;
        let type: string;

        if (params['productId']) {
            mainId = params['productId'];
            type = 'product';
        } else if (params['certificationId']) {
            mainId = params['certificationId'];
            type = 'certification';
        } else if (params['organisationId']) {
            mainId = params['organisationId'];
            type = 'organisation';
        }

        if (mainId) {
            // Build canonical params
            const targetParams: any = {};

            // 1. Set tab
            targetParams.tab = (type === 'product' ? '0' : type === 'certification' ? '1' : '2');

            // 2. Copy existing important filters without duplicating
            ['category', 'certificationType', 'ptgId', 'orgId', 'rating', 'attr'].forEach(key => {
                if (params[key] !== undefined) targetParams[key] = params[key];
            });

            // 3. Set primary IDs and their synced counterparts
            if (type === 'product') {
                targetParams.appSubPro = mainId;
                targetParams.productId = mainId;
            } else if (type === 'certification') {
                targetParams.certifiId = mainId;
                targetParams.certificationId = mainId;
            } else {
                targetParams.orgId = mainId;
                targetParams.organisationId = mainId;
            }

            const urlTree = this.router.createUrlTree([], {
                relativeTo: this.route,
                queryParams: targetParams,
                queryParamsHandling: 'merge'
            });
            const targetUrl = this.router.serializeUrl(urlTree);

            // robust comparison using serializeUrl
            const currentUrl = this.router.url;

            if (currentUrl !== targetUrl) {
                this.router.navigateByUrl(targetUrl);
            }
        }
    }

    // @HostListener('window:resize')
    // onResize() {
    //     if(this.displaySetting === "PRODUCT") {
    //         this.rearrangeTopRowsOnResize();
    //     }
    // }

    private calculateItemsPerRow(): void {
        const viewportWidth = window.innerWidth;

        const marginLeft = 272;
        const paddingLeftRight = 2 * 16;
        const scrollbarWidth = 10;
        const availableWidth = viewportWidth - marginLeft - paddingLeftRight - scrollbarWidth;

        // const itemWidth = 236;
        const itemWidth = 320;
        // const gapWidth = 32;
        const gapWidth = 16;

        let itemsPerRow = 1;

        while (true) {
            const totalItemsWidth = itemsPerRow * itemWidth;
            const totalGapsWidth = (itemsPerRow - 1) * gapWidth;
            const neededWidth = totalItemsWidth + totalGapsWidth;

            if (neededWidth > availableWidth) {
                itemsPerRow--;
                break;
            }

            itemsPerRow++;
        }

        this.itemsPerRow = Math.max(itemsPerRow, 1);
    }

    // private rearrangeItemsForTopRows(
    //     items: DisplayItemInterface[],
    //     topItemCount: number
    //     ): DisplayItemInterface[] {
    //     const highlighted = items.filter(item => item.prioritized);
    //     const normal = items.filter(item => !item.prioritized);
    //     // const highlighted = items.filter(item => item.id <=9);
    //     // const normal = items.filter(item => item.id >9);

    //     const topItems: DisplayItemInterface[] = [];

    //     while (topItems.length < topItemCount && highlighted.length > 0) {
    //         topItems.push(highlighted.shift()!);
    //     }

    //     while (topItems.length < topItemCount && normal.length > 0) {
    //         topItems.push(normal.shift()!);
    //     }

    //     const remainingItems = [...normal, ...highlighted].sort(() => Math.random() - 0.5);

    //     return [...topItems, ...remainingItems];
    // }

    // private rearrangeTopRowsOnResize(): void {
    //     this.calculateItemsPerRow();
    //     const topItemCount = this.itemsPerRow * 2;

    //     this.displayItem = this.rearrangeItemsForTopRows([...this.displayItem], topItemCount);

    //     if (!this.cd['destroyed']) {
    //         this.cd.detectChanges();
    //     }
    // }

    public productCategoryCheckboxItems: { name: string; checked: boolean; value: string; filterOption: boolean }[] = [];
    public visibleCategoryItems: { name: string; checked: boolean; value: string; filterOption: boolean }[] = [];
    public selectedFilter: string = "Software";
    onFilterChanged(selectedName: string, fromFullProductPage: boolean = false): void {
        this.spinner = true;
        if (fromFullProductPage) this.marketPlaceFilterService.setChangeProductCategoryFilter("none");
        this.loading = true;
        this.cd.detectChanges();
        this.selectedFilter = selectedName;

        // Map selected tab name to category
        const selectedItem = this.productCategoryCheckboxItems.find(item => item.name === selectedName);

        let productCategories: ProductCategory[] = [];

        if (selectedItem) {
            if (selectedItem.value === ProductCategory.ALL) {
                // Select all categories
                productCategories = [];
            } else {
                // Just the selected category
                productCategories = [selectedItem.value as ProductCategory];
            }
        }

        this.marketPlaceFilterService.setProductCategoryFilter(productCategories);
        setTimeout(() => {
            this.loading = false;
            this.spinner = false;
            this.cd.detectChanges();
        }, 2000);

    }



}

export function buildSortOptions(datatype: DataType) {
    const isCert = datatype === DataType.CERTIFICATION;
    const isOrg = datatype === DataType.ORGANISATION;
    const isProduct = datatype === DataType.PRODUCT;

    const productSortOptions = [];
    if(isProduct) productSortOptions.push({ name: SortMethod.PRODUCT_UPDATED_DESC, title: 'Letzte Produktaktualisierung' });

    const alphabeticalOptions = [
        {
            name: SortMethod.ALPHABETICAL_ASC,
            title: isCert
                ? 'Zertifikate Name (A-Z)'
                : isOrg
                    ? 'Anbieter Name (A-Z)'
                    : 'Produktname (A-Z)',
        },
        {
            name: SortMethod.ALPHABETICAL_DESC,
            title: isCert
                ? 'Zertifikate Name (Z-A)'
                : isOrg
                    ? 'Anbieter Name (Z-A)'
                    : 'Produktname (Z-A)',
        },
    ];
    if (isOrg) { return alphabeticalOptions; }

    return [
        ...productSortOptions,
        { name: SortMethod.DATE_DESC, title: 'Neueste Veröffentlichung' },
        { name: SortMethod.DATE_ASC, title: 'Früheste Veröffentlichung' },
        ...alphabeticalOptions,
    ];
}
